import React, { Component } from "react";
import { withStyles } from "@material-ui/core/styles";
import PropTypes from "prop-types";
import "../../styles/css/ElevationForm/elevationForm.css";

import { FilePond, File, registerPlugin } from "react-filepond";
import FilePondPluginImageExifOrientation from "filepond-plugin-image-exif-orientation";
import FilePondPluginImagePreview from "filepond-plugin-image-preview";
import "filepond-plugin-image-preview/dist/filepond-plugin-image-preview.css";
import FilePondPluginFileValidateType from "filepond-plugin-file-validate-type";
// import FilePondPluginFileEncode from "filepond-plugin-file-encode";

registerPlugin(
  FilePondPluginImageExifOrientation,
  FilePondPluginImagePreview,
  FilePondPluginFileValidateType
  // FilePondPluginFileEncode
);

class SectionD extends Component {
  constructor(props) {
    super(props);
    this.state = {
      attachmentd: "",
    };
    this.onUploadImage = this.onUploadImage.bind(this);
  }

  onUploadImage(e) {
    this.setState({
      attachmentd: e.target.value,
    });
  }
  render() {
    const {
      sectionD,
      onClickD,
      validateD,
      removeTag,
      inputKeyDown,
    } = this.props;

    return (
      <div>
        <div className="form-wrapper-elevation">
          <h2>SURVEYOR, ENGINEER, OR ARCHITECT CERTIFICATION</h2>
          {sectionD.isSubmittedD === false ? (
            <div className="err-msg-content">
              Something went wrong. Please try again.
            </div>
          ) : null}

          <table>
            <tbody>
              <tr>
                <td colSpan="6">
                  <div>
                    <p className="sub-question-title">
                      This certification is to be signed and sealed by a land
                      surveyor, engineer, or architect authorized by law to
                      certify elevation information. <br></br>
                      <i>
                        I certify that the information on this Certificate
                        represents my best efforts to interpret the data
                        available.I understand that any false statement may be
                        punishable by fine or imprisonment under 18 U.S. Code,
                        Section 1001.
                      </i>
                    </p>
                  </div>
                </td>
              </tr>
              <tr>
                {/* <td colSpan="4">
                  <div className="question-wrapper">
                    <p className="qst-type">
                      Were latitude and longitude in Section A provided by a
                      licensed land surveyor?
                    </p>
                  </div>
                </td> */}
                <td colSpan="6">
                  <div className="input-horizontal">
                    <label>
                      Were latitude and longitude in Section A provided by a
                      licensed land surveyor?
                    </label>
                    <input
                      checked={sectionD.Islicensed_surveyor === "Yes"}
                      type="radio"
                      name="Islicensed_surveyor"
                      value="Yes"
                      className="section-d-radio"
                      onChange={onClickD}
                    />
                    <label className="checkbox-label"> Yes</label>
                    <input
                      checked={sectionD.Islicensed_surveyor === "No"}
                      type="radio"
                      name="Islicensed_surveyor"
                      value="No"
                      className="section-d-radio"
                      onChange={onClickD}
                    />
                    <label className="checkbox-label"> No</label>
                  </div>
                  {validateD.message(
                    "value",
                    sectionD.Islicensed_surveyor,
                    "alpha_num_dash_space",
                    { className: "error-msg-text" }
                  )}
                </td>
              </tr>

              <tr>
                <td colSpan="6">
                  <div className="sectiond-wrapper">
                    <div className="leftside-wrapper">
                      <div className="inline-question-two">
                        <div className="block-divider">
                          <p className="sub-question-title">Certifier's Name</p>
                          <div className="input-box-wrapper">
                            <input
                              disabled
                              name="certifier_name"
                              type="text"
                              className="form-input-box"
                              // value={sectionD.profileData.first_name}
                              value={sectionD.certifier_name}
                              onChange={onClickD}
                            />
                          </div>
                        </div>
                        <div className="block-divider">
                          <p className="sub-question-title">License Number</p>
                          <div className="input-box-wrapper">
                            <input
                              disabled
                              name="certifier_license_no"
                              type="text"
                              className="form-input-box"
                              value={sectionD.certifier_license_no}
                              onChange={onClickD}
                            />
                          </div>
                        </div>
                      </div>
                      <div>
                        {" "}
                        <p className="sub-question-title">Title</p>
                        <div className="input-box-wrapper">
                          {" "}
                          <input
                            disabled
                            name="certifier_designation"
                            type="text"
                            className="form-input-box"
                            value={sectionD.certifier_designation}
                            onChange={onClickD}
                          />
                        </div>
                      </div>
                      <div>
                        <p className="sub-question-title">Company Name</p>
                        <div className="input-box-wrapper">
                          <input
                            disabled
                            name="certifier_company"
                            type="text"
                            className="form-input-box"
                            value={sectionD.certifier_company}
                            onChange={onClickD}
                          />
                        </div>
                      </div>
                      <div>
                        {" "}
                        <p className="sub-question-title">Address</p>
                        <div className="input-box-wrapper">
                          <input
                            disabled
                            name="certifier_address"
                            type="text"
                            className="form-input-box"
                            value={sectionD.certifier_address}
                            onChange={onClickD}
                          />
                        </div>
                      </div>
                    </div>
                    <div className="rightside-wrapper">
                      {" "}
                      <textarea
                        disabled
                        rows="14"
                        className="form-input-textarea"
                        placeholder="Place Seal Here"
                      />{" "}
                    </div>
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="3">
                  <p className="sub-question-title">City</p>
                  <div className="input-box-wrapper">
                    <input
                      disabled
                      name="certifier_city"
                      type="text"
                      className="form-input-box"
                      value={sectionD.certifier_city}
                      onChange={onClickD}
                    />
                  </div>
                </td>
                <td colSpan="2">
                  <p className="sub-question-title">State</p>
                  <div className="input-box-wrapper">
                    {" "}
                    <input
                      disabled
                      name="user_state"
                      type="text"
                      className="form-input-box"
                      value={sectionD.user_state}
                      onChange={onClickD}
                    />
                  </div>
                </td>
                <td colSpan="1">
                  <p className="sub-question-title">ZIP Code</p>
                  <div className="input-box-wrapper">
                    <input
                      disabled
                      name="user_zipcode"
                      type="text"
                      className="form-input-box"
                      value={sectionD.user_zipcode}
                      onChange={onClickD}
                    />
                  </div>
                </td>
              </tr>
              <tr>
                <td colSpan="3" rowSpan="2">
                  <p className="sub-question-title">Signature</p>
                  <div className="input-box-wrapper">
                    {sectionD.user_signature !== false ? (
                      <img
                        src={sectionD.user_signature}
                        alt=""
                        style={{
                          width: "200px",
                          maxHeight: "200px",
                        }}
                      ></img>
                    ) : sectionD.user_signature === false ? (
                      <div className="signature-wrapper">
                        Signature is not available
                      </div>
                    ) : // <FilePond
                    //   acceptedFileTypes={["image/png", "image/jpeg"]}
                    //   ref={(ref) => (this.pond = ref)}
                    //   files={sectionD.surveyor_sign}
                    //   allowMultiple={false}
                    //   maxFiles={1}
                    //   name="files"
                    //   labelIdle="Click here or drop your files here"
                    //   onupdatefiles={(fileItems) => {
                    //     this.props.signatureData(fileItems);
                    //   }}
                    // ></FilePond>
                    null}
                  </div>
                </td>
                <td colSpan="3">
                  {" "}
                  <p className="sub-question-title">Equipment</p>
                  <div className="input-box-wrapper">
                    {/* <div className="equipment-tag">
                      <ul className="equipment-tag__tags">
                        {sectionD.equipment !== null
                          ? sectionD.equipment.map((tag, i) => (
                              <li key={tag}>
                                {tag}
                                <button
                                  type="button"
                                  onClick={() => {
                                    removeTag(i);
                                  }}
                                >
                                  +
                                </button>
                              </li>
                            ))
                          : null}
                        <li className="equipment-tag__tags__input">
                          <input
                            placeholder="Enter equipments"
                            type="text"
                            onKeyDown={inputKeyDown}
                            ref={(c) => {
                              this.props.tagInput = c;
                            }}
                          />
                        </li>
                      </ul>
                    </div> */}

                    <input
                      disabled
                      name="equipment"
                      type="text"
                      className="form-input-box"
                      value={sectionD.equipment}
                      onChange={onClickD}
                    />
                    {/* {validateD.message(
                      "value",
                      sectionD.equipment,
                      "alpha_num_dash_space",
                      { className: "error-msg-text" }
                    )} */}
                  </div>
                </td>
              </tr>

              <tr>
                <td>
                  <div className="inline-question-container">
                    <div>
                      <p className="sub-question-title">Date</p>
                      <div className="input-box-wrapper">
                        <input
                          type="text"
                          name="user_date"
                          value={sectionD.user_date}
                          className="form-input-box"
                          onChange={onClickD}
                        />
                      </div>
                    </div>
                    <div>
                      <p className="sub-question-title">Telephone</p>
                      <div className="input-box-wrapper">
                        <input
                          disabled
                          name="user_telephone"
                          type="number"
                          className="form-input-box"
                          value={sectionD.user_telephone}
                          onChange={onClickD}
                        />
                      </div>
                    </div>
                    <div>
                      <p className="sub-question-title">Ext</p>
                      <div className="input-box-wrapper">
                        {" "}
                        <input
                          disabled
                          name="user_ext"
                          type="text"
                          className="form-input-box"
                          value={sectionD.user_ext}
                          onChange={onClickD}
                        />
                      </div>
                    </div>
                  </div>
                </td>
              </tr>

              <tr>
                <td colSpan="6">
                  <p className="sub-question-title">
                    Comments (including type of equipment and location, per
                    C2(e), if applicable)
                  </p>

                  <div className="input-box-wrapper">
                    <textarea
                      name="comments_for_D"
                      value={sectionD.comments_for_D}
                      onChange={onClickD}
                      rows="10"
                      cols="30"
                      maxLength="1000"
                      className="form-input-textarea"
                    ></textarea>
                  </div>
                  <div className="check-label-note">
                    <input
                      type="checkbox"
                      value="open"
                      name="attachmentd"
                      onChange={this.onUploadImage}
                      className="checkbox-icon-btn"
                    />
                    <label className="qst-type">
                      Check here if attachments
                    </label>
                  </div>
                  {this.state.attachmentd === "open" ? (
                    <div>
                      <FilePond
                        // allowFileEncode={true}
                        acceptedFileTypes={[
                          "application/pdf",
                          "image/png",
                          "image/jpeg",
                        ]}
                        ref={(ref) => (this.pond = ref)}
                        files={sectionD.survey_attachment}
                        allowMultiple={true}
                        maxFiles={5}
                        name="files"
                        labelIdle="Click here or drop your files here"
                        onupdatefiles={(fileItems) => {
                          this.props.imagedata(fileItems);
                        }}
                      ></FilePond>
                    </div>
                  ) : null}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    );
  }
}

export default SectionD;



// WEBPACK FOOTER //
// ./src/pages/ElevationForm/SectionD.js